/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */

import { ConfluenceSearchConfigModalWithWrappers } from './ConfluenceSearchConfigModalWithWrappers';

export const CONFLUENCE_SEARCH_DATASOURCE_ID = '768fc736-3af4-4a8f-b27e-203602bff8ca';

export default ConfluenceSearchConfigModalWithWrappers;

/**
 * @deprecated Use `import { ConfluenceSearchConfigModalWithWrappers } from '@atlaskit/link-datasource/confluence-search-config-modal-with-wrappers'` instead.
 */
export { ConfluenceSearchConfigModalWithWrappers } from './ConfluenceSearchConfigModalWithWrappers';
/**
 * @deprecated Use `import { ConfluenceSearchConfigModalWithWrappers } from '@atlaskit/link-datasource/confluence-search-config-modal-with-wrappers'` instead.
 */
export { ConfluenceSearchConfigModalWithWrappers as ConfluenceSearchConfigModal } from './ConfluenceSearchConfigModalWithWrappers';
